import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IPageDataV2, IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { NICmsContentField } from '@icms/core/content/interfaces/icms-content-field.interfaces';
import { ICmsPageType } from '@icms/core/content/page/icms-page-type.decorator';
import { LocalPage } from 'projects/app-default/src/app/catalog/page/local/local-page';
import { ICmsOutletBlockComponent } from '../../../catalog/outlet-block/icms-outlet-block.component';
import { PageViewAbstract } from '../../../catalog/page/view/page-view.abstract';

export const INFORMATION_TAB = 'Information';

export namespace NInformationRootPageType {
    export const typeId = 'information-root';

    export interface ITypeData {
        title: string;
        /**
         * Copy belop page title
         */
        copy: string;
        bottomComponents: NICmsContentComponent.IData[];
    }
}

@ICmsPageType({
    id: NInformationRootPageType.typeId,
    title: 'Information root',
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'typeData.title',
            title: 'Title',
            tab: INFORMATION_TAB,
            default: 'Help and support',
            required: true
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'typeData.copy',
            title: 'Copy',
            tab: INFORMATION_TAB
        }
    ]
})
@Component({
    selector: 'cms-information-root-page',
    templateUrl: './cms-information-root-page.html',
    styleUrl: './cms-information-root-page.scss',
    imports: [ICmsClientModule, RouterLink, TranslatePipe, ICmsOutletBlockComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsInformationRootPageComponent extends PageViewAbstract {
    @Input()
    override model?: LocalPage<IPageDataV3<NInformationRootPageType.ITypeData>>;

    @Input()
    data: IPageDataV3 | undefined;

    @Input()
    @ICmsContent({
        watchDepth: 1
    })
    typeData: NInformationRootPageType.ITypeData | undefined;

    get children() {
        return this.model?.children as LocalPage<IPageDataV2>[] | undefined;
    }

    protected get components(): NICmsContentComponent.IData[] {
        return this.model?.data?.components || [];
    }

    isSmallItem(index: number) {
        if (!this.children?.length) {
            return true;
        }
        if ((this.children?.length - 4) % 3 === 0) {
            return index > 3;
        }
        if ((this.children?.length - 2) % 3 === 0) {
            return index > 1;
        }
        return true;
    }
}
